import { LOCALES } from "../locales";

export default {
  [LOCALES.ITALIAN]: {
    // general product translation
    January: "gennaio",
    February: "febbraio",
    March: "marzo",
    April: "aprile",
    May: "maggio",
    June: "giugno",
    July: "luglio",
    August: "agosto",
    September: "settembre",
    October: "ottobre",
    November: "novembre",
    December: "dicembre",
    class_policy: "Regole della lezione",
    Faq: "FAQ",
    help: "Guida",
    category: "Categoría",
    frequently_asked_ques: "Domande frequenti (FAQ)",
    customer_support: "Assistenza clienti",
    user_name: "Nome utente",
    password: "Password",
    email_address: "Indirizzo e-mail",
    // Header Translations
    notification: "Notifica",
    page_loading_aria: "La pagina è in loading",
    state_loading_aria: "Lo Stato è in loading",
    city_loading_aria: "La città è in loading",
    badge_placeholder: "Badge placeholder",
    badge_overall: "Badge generale",
    badge_demo_skills: "Badge placeholder for demo user, skills",
    badge_demo_be: "Badge placeholder for demo user, business english",
    certificate_placeholder: "Immagine del certificato",
    certificate_download: "Pulsante per scaricare il certificato",
    prev: "Precedente",
    log_out: "Disconnetti",
    //navbar
    navbar_course: "Corso",
    navbar_tools: "Strumenti",
    navbar_skill_index: "Competenze",
    navbar_level_index: "Livelli",
    navbar_schedule: "Programma",
    // feature names
    feature_progress: "Progresso",
    feature_stressAndIntonation_title: "Accento e intonazione",
    feature_soundOfEnglish_title: "I suoni dell’inglese",
    feature_vocabularyCenter_title: "Sezione del vocabolario",
    feature_grammarCenter_title: "Sezione della Grammatica",
    feature_culture_centre_title: "Note Culturali",
    feature_globalCommunityTutorials_title: "Global community tutorials",
    feature_industryfeed_title: "Esercizi personalizzati sui settori industriali",
    feature_newsfeed_title: "News feed",
    feature_emailTemplates_title: "Modelli di e-mail",
    feature_talkWithTeacher_title: "Talk with teacher",
    feature_accentsAndDialects_title: "Accenti e dialetti",
    feature_writingCenter_title: "Centro di Scrittura",
    feature_toeic_title: "TOEIC",
    feature_toefl_title: "TOEFL",
    // Footer translations
    about: "Informazioni",
    legal: "Note legali",
    privacy_policy: "Norme sulla privacy",
    Terms_conditions: "Condizioni d'uso",
    //button translations
    button_continue: "Continua",
    button_KnowMore: "Per saperne di più",
    button_BuyNow: "Compra adesso",
    button_Subscribe: "Sono d'accordo",
    button_GetStarted: "Inizia",
    button_GetResult: "Ottieni risultati",
    button_GetLoading: "Loading...",
    button_view: "Vitualizza",
    button_GoText: "Vai",
    button_Resume: "Continua ad apprendere",
    button_ViewDetails: "Vitualizza i dettagli",
    button_ContinueStudying: "Continua",
    button_next: "Successiva",
    button_confirm: "Conferma",
    // cookie policy
    common_cookiesPolicyText1:
      "Learnship utilizza i cookie per garantire il miglior servizio possibile. Rimanendo sul sito acconsenti al miglioramento del servizio. Leggi la nostra",
    common_cookiesPolicyText2: "politica sull‘uso dei cookie",
    // EO cookie policy
    //login-page-translations//
    login_welcome: "Benvenuto/a,",
    login_heloo: "Salve di nuovo",
    login_welcome_text: "Cominciamo.",
    login_log_in: "Accedi",
    login_errorIncorrectCreds: "Nome utente o password non corretti",
    login_errorContactAmin: "Il tuo account non è attivo. Si prega di contattare l'amministratore.",
    login_errorSSOuser: "Devi effettuare l'accesso dal portale di apprendimento della tua azienda.",
    login_forgotPassword: "Ha dimendicato la password?",
    login_resetPasswordTitle: "Reimposta password",
    login_resetSuccess:
      "Ti abbiamo inviato una mail contenente un link che ti consentirà di reimpostare la tua password.",
    login_resetFailure: "L'indirizzo email non è corretto",
    // common translations
    message_errorDefault: "Si è verificato un errore",
    message_successUpdated: "Aggiornamento riuscito",
    message_unknownError: "Errore sconosciuto",
    message_unAuthorized: "Sei autorizzato ad accedere a questa pagina",
    message_passwordUpdated: "Aggiornamento della password riuscito",
    message_profileUpdated: "Aggiornamento del profilo riuscito",
    message_welcomeSubmitted: "Inviato correttamente",
    message_samepasswordError:
      "Si prega di inserire una nuova password. Assicurati che non si tratti di una password già utilizzata.",
    SAR: "Seleziona una regione",
    SAL: "Seleziona una località",
    SAT: "Seleziona un argomento",
    SAA: "Seleziona una lingua",
    link_readmore: "Altre informazioni",
    //--//

    // Idle Timer
    session_expiring: "Sessione in scadenza",
    timer_title_1: "La Sua sessione sta per scadere.",
    timer_title_2: "Per continuare a studiare, clicchi su Ok.",
    ok_timer: "Ok",
    profile_title: "Profilo",
    profile_nameLabel: "Mi chiamo:",
    profile_countryLabel: "Paese",
    profile_stateLabel: "Stato/Provincia/Regione",
    profile_cityLabel: "Città",
    profile_emailLabel: "Email",
    profile_prefContactLabel: "Metodo di contatto preferito",
    profile_prefSkypeLabel: "ID Skype (Personale)",
    profile_prefMobileLabel: "Numero di cellulare",
    profile_prefLandlineLabel: "Numero di linea fissa",
    profile_agreeTerms1: " ",
    profile_agreeTerms2: "Accetto e concordo con i termini e le condizioni",
    profile_continueAria: "Pulsante continua",
    profile_TermsAria: "Accetto i termini e le condizioni",
    profile_stateTooltip: "Il tuo fuso orario ci aiuterà a programmare le tue sessioni online.",
    profile_cityTooltip:
      "Se non vivi in nessuna delle città elencate qui sotto, ti preghiamo di selezionare la città più vicina alla tua.",
    profile_emailTooltip: "Verifica il tuo indirizzo email",
    profile_prefTooltip:
      "Tutte le tue sessioni si svolgeranno nella classe virtuale, anche se hai specificato un metodo di contatto differente nel processo di inserimento delle informazioni iniziali. Ti abbiamo chiesto il tuo metodo di contatto preferito solo per uso interno, in modo da poter migliorare continuamente la tua esperienza di apprendimento.",
    profile_fnamePlaceholder: "Nome",
    profile_lnamePlaceholder: "Cognome",
    profile_countryPlaceholder: "Seleziona un Paese",
    profile_prefContactSelect: "Seleziona la tua preferenza",
    profile_statePlaceholder: "Seleziona uno Stato",
    profile_cityPlaceholder: "Seleziona una città",
    profile_emailInvalidMessage: "L'indirizzo email non è valido",
    profile_prefContactPlaceholder: "Scegli la tua preferenza",
    profile_prefSkypePlaceholder: "Skype (Personale)",
    profile_emailVerifiedChip: "Verificato",
    profile_emailVerifyChip: "Verifica",
    profile_emailpopup_head: "Inserisci il codice di verifica",
    profile_emailpopup_codePlaceholder: "Code",
    profile_emailpopup_resendText: "Rimanda il codice",
    profile_emailpopup_resendMessage: "Non hai ricevuto il codice?",
    profile_invalidNumber: "Numero non valido",
    profile_prefSkypeAria: "Metodo di contatto preferito: ID Skype (Personale)",
    profile_prefMobileAria: "Metodo di contatto preferito: cellulare",
    profile_prefLandlineAria: "Metodo di contatto preferito: linea fissa",
    profile_emailpopup_incorrectCode: "Codice non valido",
    profile_editLabel: "Modifica il profilo",
    profile_editAria: "Pulsante di modifica",
    profile_mainPasswordPlaceholder: "Inserisci qui la password",
    profile_updateLabel: "Aggiorna",
    profile_welcomeJumbotron: "Dicci qualcosa di te.",
    profile_cancelLabel: "Annulla",
    noAccessl1: "Oops! Non hai il permesso di vedere questa pagina.",
    noAccessl2: "Qui trovi il link per tornare indietro alla",
    noAccessl2_1: "homepage",
    noAccessl3: "Se hai bisogno di aiuto, ti preghiamo di contattare il tuo Amministratore di Learnship.",
    license_information: "La mia licenza",
    profile_license_information: "Informazioni sulla licenza",
    profile_license_message: "La vostra licenza scade il",
    profile_changepass_changepassHead: "Modifica la password",
    profile_changepass_currentpassword: "Password attuale",
    profile_changepass_currentpasswordPlaceholder: "Inserisci la password attuale",
    profile_changepass_newpassword: "Nuova password",
    profile_changepass_newpasswordPlaceholder: "Inserisci la nuova password",
    profile_changepass_confirmnewpassword: "Conferma la nuova password",
    profile_passMustInclude: "La password deve contenere:",
    profile_passdontmatch: "Le password non corrispondono",
    profile_incorrectPassword: "Password non corretta",
    profile_passwordSubmit_title: "Inserisci la password",
    profile_changepass_conditionLength: "Tra 8 e 12 caratteri",
    profile_changepass_conditionUppercase: "Almeno una lettera maiuscola",
    profile_changepass_conditionLowercase: "Almeno una lettera minuscola",
    profile_changepass_conditionSpecialCharacters: "Almeno una cifra numerica e uno di questi simboli $!#&@?%*_",
    profile_translationLanguage: "Lingua di traduzione",
    profile_translationLanguagePlaceholder: "Scegli una lingua",
    profile_managerEmailPlaceholder: "Email del Manager",
    profile_managerEmailpopupPlaceholder: "Indirizzo email del Manager",
    // Learner Home Page translations
    learnerhome_survey_header: "Abbiamo bisogno del tuo feedback!",
    learnerhome_survey_line1: "La tua azienda vorrebbe sapere come ti sei trovato con i nostri servizi.",
    learnerhome_survey_line2: "Ti preghiamo di completare il nostro sondaggio",
    learnerhome_survey_line3: "Il tuo feedback è molto importante ed enormemente apprezzato",
    learnerhome_survey_button1: "Partecipa al sondaggio",
    learnerhome_survey_button2: "Salta il sondaggio",
    active_course: "Attiva il corso",
    admin_header: "Amministrazione",
    admin_dashboard_header: "Dashboard",
    get_startedText: "Clicca su un corso qui in basso per cominciare",
    product_solo_desc:
      "Learnship Solo, il nostro prodotto di e-learning, fornisce agli studenti tutto ciò di cui hanno bisogno per praticare e migliorare le loro abilità nella lingua aziendale che stanno studiando, seguendo e assecondando il loro personale ritmo di apprendimento.",
    product_conversationPractice_desc:
      "Gli studenti possono programmare lezioni individuali con un formatore per porre delle domande, discutere su una questione specifica o inscenare dei role-play. Uno strumento utile per gli studenti con più esperienza che desiderano affinare le proprie abilità linguistiche.",
    product_sprint_businessSkills_desc:
      "Questo programma di apprendimento misto, di ultima generazione, sviluppa, in tempi record, competenze aziendali specifiche - presentare, negoziare, scrittura aziendale e partecipazione alle riunioni -.",
    product_sprint_levelsProgress_desc:
      "Il nostro programma di apprendimento misto, di ultima generazione, aiuta il tuo personale a migliorare rapidamente le abilità in lingua inglese, rispettando un quadro standardizzato.",
    product_sprint_business_german_desc:
      "Il nostro programma di apprendimento misto, di ultima generazione, aiuta il Suo personale a migliorare rapidamente le abilità in lingua tedesca, rispettando un quadro standardizzato.",
    product_sprint_business_french_desc:
      "Il nostro programma di apprendimento misto, di ultima generazione, aiuta il Suo personale a migliorare rapidamente le abilità in lingua francese, rispettando un quadro standardizzato.",
    product_sprint_business_spanish_desc:
      "Il nostro programma di apprendimento misto, di ultima generazione, aiuta il Suo personale a migliorare rapidamente le abilità in lingua spagnola, rispettando un quadro standardizzato.",
    product_sprint_business_skills_groups_desc:
      "This next-generation blended learning program helps learners develop specific business skills— in groups—in record time.",
    product_evolve_relocationLanguage_desc:
      "Il nostro programma, creato per i dipendenti trasferitisi in altri paesi, aiuta gli studenti a maturare una conoscenza approfondita sia della lingua sia delle nuance linguistiche del loro nuovo paese di residenza.",
    product_evolve_culturePowerSkills_desc:
      "Fornisci ai tuoi dipendenti le competenze interculturali chiave di cui hanno bisogno per dare il meglio negli ambienti di lavoro e nei team virtuali globali.",
    product_evolve_cultureFocus_desc:
      "Una formazione specifica sul Paese di destinazione e sull'intelligenza culturale per coloro che desiderano acquisire una comprensione più dettagliata di una regione specifica e dell'ambiente lavorativo di quest'ultima.",
    product_evolve_cultureChange_desc:
      "Questo è il nostro programma principale di formazione aziendale interculturale per i dipendenti che sono stati trasferiti. Fornisce agli studenti una comprensione approfondita di ciò che serve per vivere e lavorare in una nuova cultura.",
    product_elevate_businessSkills_desc:
      "Brevi moduli di apprendimento standardizzati per studenti che desiderano migliorare alcune specifiche competenze aziendali come per esempio presentazioni, negoziazioni o leadership di un team. Offriamo inoltre corsi specialistici incentrati sui linguaggi degli specifici settori industriali.",
    product_elevate_levelsProgress_desc:
      "Questo corso di lingua aziendale, affiancato dalla guida di un formatore, aiuta gli studenti a migliorare le abilità scritte e orali seguendo un quadro standardizzato.",
    product_coach_languageCoach_desc:
      "Comunica con sicurezza e chiarezza durante le riunioni, nelle e-mail, nelle trattative e persino parlando dei distributori dell'acqua. Il nostro coaching linguistico individuale e iper-specifico per dirigenti ti aiuterà a padroneggiare gli scenari aziendali più importanti. Svilupperà le tue capacità di comunicazione orale, scritta e personale anche durante i meeting.",
    product_coach_cultureCoach_desc:
      "Un programma di coaching individuale e iper-focalizzato per dirigenti che cercano di risolvere problemi specifici di comunicazione interculturale.",
    product_solo_business_english:
      "Un programma di apprendimento multi-livello con coinvolgenti esercizi online per sviluppare, seguendo il tuo ritmo personale, la conoscenza e l’applicazione dell’inglese aziendale.",
    product_solo_business_german:
      "Un programma di apprendimento multi-livello con coinvolgenti esercizi online per sviluppare, seguendo il tuo ritmo personale, la conoscenza e l’applicazione del tedesco aziendale.",
    product_solo_business_french:
      "Un programma di apprendimento multi-livello con coinvolgenti esercizi online per sviluppare, seguendo il tuo ritmo personale, la conoscenza e l’applicazione del francese aziendale.",
    product_solo_business_spanish:
      "Un programma di apprendimento multi-livello con coinvolgenti esercizi online per sviluppare, seguendo il tuo ritmo personale, la conoscenza e l’applicazione dello spagnolo aziendale.",
    product_lorem_desc: "Lorem Ipsum lorstatment , consect eturadips cingelioremp.",
    product_dashboard_desc:
      "Questo è il tuo gateway al Dashboard – un interfaccia intuitivo che consente agli amministratori di tracciare l’utilizzo, analizzare I progressi dello studente, ottimizzare i programmi e valutare il ROI.",
    product_elevate_desc:
      "Elevate Business English è il nostro corso di formazione, online e face-to-face, pensato per coloro che desiderano perfezionare la padronanza linguistica globale, lavorando con un formatore personale.",
    product_reach_desc:
      "Enhance your learning journey with personalized micro-modules and side missions focusing on real-world business skills.",
    product_lorem_solo_desc:
      "Questo ricco programma multimediale aiuterà i tuoi dipendenti a perfezionare rapidamente le loro competenze in inglese secondo un quadro standardizzato.",
    //feature translations
    feature_cultureCentre_desc:
      "Familiarizzi con le culture di quelle regioni che sono importanti per il Suo lavoro e per la Sua vita professionale.",
    feature_emailTemplates_desc:
      "I modelli di email coprono un'ampia varietà di argomenti aziendali. Seleziona il modello che desideri ed esportalo direttamente nel tuo client di posta elettronica dove puoi modificarlo.",
    feature_newsFeed_desc:
      "Benvenuti nella nostra rivoluzionaria esperienza di notizie dal mondo! Impara e perfeziona l'inglese attraverso i contenuti e le domande che vengono generati in diretta dal nostro sistema.",
    feature_talkWithTeacher_desc:
      "È stato creato per quegli studenti che desiderano applicare le loro nuove abilità nella conversazione pratica. Gli utenti possono unirsi a dei gruppi in delle classi virtuali per praticare la lingua prescelta e prendere parte alle sessioni di domande e risposte con degli specialisti del parlato.",
    feature_industryFeed_desc:
      "Le risorse per gli esercizi linguistici vengono combinate con articoli specifici dei vari settori industriali e potenziati dall'Intelligenza Artificiale. Scegli un articolo e un argomento di grammatica che desideri praticare.",
    feature_accentsAndDialects_desc:
      "Esplora la ricchezza delle varietà mondiali dell'inglese attraverso la nostra biblioteca di esempi di parlato regionali.",
    feature_stressAndIntonation_desc:
      "Rendi il tuo inglese parlato più naturale e più comprensibile usando nel modo corretto l'accento, il ritmo e l'intonazione.",
    feature_soundOfEnglish_desc:
      "Migliora le tue competenze comunicative pronunciando correttamente i suoni dell'inglese.",
    feature_vocabularyCenter_desc:
      "Senza grammatica, si può comunicare pochissimo. Senza vocabolario non si può comunicare per niente. - David Wilkins",
    feature_grammarCenter_desc:
      "IL Centro Studi sulla Grammatica ti aiuterà ad utilizzare la grammatica correttamente nel parlato e nello scritto. Il Centro si focalizza su argomenti grammaticali, come le parti della frase, i verbi e le forme dei verbi, le frasi e le proposizioni.",
    feature_globalCommunityTutorials_desc:
      "Migliora le tue competenze in lingua inglese con questa collezione in continua crescita di lezioni sviluppate dalla comunità.",
    feature_toeic_desc:
      "Il test TOEIC® è lo strumento più largamente utilizzato dalle multinazionali per valutare la conoscenza dell’inglese dei propri dipendenti. Il TOEIC® utilizza materiali scritti autentici e dialoghi per valutare le tue competenze in inglese aziendale.",
    feature_toefl_desc:
      "Il TOEFL®, Test di inglese come lingua straniera, viene usato in tutto il mondo per valutare la conoscenza dell'inglese nei college e nelle Università, e anche dalle agenzie governative e dai programmi per l’assegnazione di borse di studio.",
    feature_businessSituations_desc:
      "L'Indice delle Situazioni Aziendali facilita il compito di trovare attività specifiche in modo da concentrarsi sul linguaggio di cui hai bisogno per comunicare in un'ampia varietà di situazioni aziendali.",
    //carousel block translations
    title_feature: "Caratteristiche",
    we_recommend: "Consigliamo inoltre",
    // session report translations
    SessionReport_sessionReport: "Report sulla sessione",
    SessionReport_sessionDetails: "Dettagli",
    SessionReport_teacherName: "Nome del formatore",
    SessionReport_sessionReview: "Rivedi la sessione",
    SessionReport_sessionFeedback: "Feedback sulla sessione",
    SessionReport_sessionMaterials_Assignments: "Materiale e Assegno della sessione",
    SessionReport_instructions: "Istruzioni",
    SessionReport_open: "Aprire",
    SessionReport_invalidSession_Message: "Siamo spiacenti, non ci sono report per questa sessione.",
    SessionReport_rateSession: "Valuta la sessione",
    SessionReport_handouts: "Foglietto informativo",
    SessionReport_coachName: "Com'è andata la tua sessione con",
    SessionRating_sessionDate: "Data della sessione",
    SessionRating_sessionTime: "Ora della sessione",
    SessionRating_sessionDuration: "Durata della Sessione",
    SessionRating_status: "Stato",
    SessionRating_rateYourExperience: "Valuta la Tua esperienza",
    SessionRating_whatWentWrong: "Cosa è andato storto?",
    SessionRating_content: "Contenuto",
    SessionRating_technology: "Tecnologia",
    SessionRating_comment: "Lascia un commento",
    SessionRating_submit: "Invia",
    SessionRating_remindMeLater: "Ricordamelo più tardi",
    SessionRating_close: "Chiudi",
    SessionRating_completed: "Finito",
    sessionRating_sessionDetails_mins: "Minuti",
    // my schedule page translations
    myschedule_availability_abty_given: "Stiamo lavorando per abbinarti a un formatore.",
    myschedule_schedule: "Il mio calendario",
    myschedule_availability_needAvl:
      "Abbiamo bisogno di conoscere la tua disponibilità per poter programmare le tue sessioni",
    myschedule_availability_abty_not_given: "Fornire / Modificare la tua disponibilità",
    myschedule_statusCard_completed: "Sessione completata",
    myschedule_statusCard_remaining: "Sessioni rimanenti",
    myschedule_statusCard_scheduled: "Sessioni da programmare",
    myschedule_statusCard_lost: "Sessioni perse (cancellazione tardiva o assenza)",
    myschedule_recentUpcoming_courseName: "Nome del Corso",
    myschedule_next_session: "Prossima sessione",
    myschedule_session_topic: "Argomento della sessione",
    myschedule_sessionDetails_communication: "Comunicazioni",
    myschedule_sessionDetails_allSessions: "Tutte le sessioni",
    myschedule_sessionDetails_upcomingSessions: "Prossime sessioni",
    myschedule_sessionDetails_completedSessions: "Sessioni completate",
    myschedule_sessionDetails_missedSessions: "Sessioni perse",
    myschedule_sessionDetails_teacher_name: "Formatore",
    myschedule_sessionDetails_sessions: "Numero",
    myschedule_sessionDetails_date: "Data",
    myschedule_sessionDetails_time: "Ora",
    myschedule_sessionDetails_durationText: "Durata",
    myschedule_sessionDetails_min: "Min.",
    myschedule_reschedule_Title: "Come riprogrammare una sessione",
    myschedule_reschedule_InstrBegin: "Qui ti spiega come si riprogrammare le tue sessioni con il formatore:",
    myschedule_reschedule_instr1a: "In alto puoi controllare i dettagli della sessione",
    myschedule_reschedule_instr1b: "In alto puoi visualizzare la data e l’ora della tua sessione.",
    myschedule_reschedule_instr2: "La disponibilità del formatore è visualizzata in verde",
    myschedule_reschedule_instr3:
      "Puoi vedere la disponibilità del tuo formatore. Le fasce orarie in verde corrispondono alle ore disponibili.",
    myschedule_reschedule_instr4: "Seleziona una fascia oraria per riprogrammare",
    myschedule_reschedule_instr5:
      "Per riprogrammare, clicca sulle fasce orarie in verde a seconda dell'orario che preferisci.",
    myschedule_reschedule_next_instr1: "Non ci sono fasce orarie disponibili",
    myschedule_reschedule_next_instr2:
      "Cerca di evitare le cancellazioni, se proprio non riesci a trovare un orario adatto con il tuo formatore, utilizza il pulsante “Nessuna fascia oraria adatta” per cancellare la sessione. In questo caso, il tuo formatore riprogrammerà questa sessione per te o un amministratore ti aiuterà a farlo.",
    myschedule_reschedule_next_instr3: "Cambiare il tuo formatore",
    myschedule_reschedule_next_instr4a:
      "É possibile cambiare il tuo Coach per una singola sessione o per più sessioni rimanenti. Per farlo, ti preghiamo di utilizzare il nostro",
    myschedule_reschedule_next_instr4b: "Modulo di contatto",
    myschedule_reschedule_next_instr4c:
      "e selezionare {productname} + “Cambia formatore”. Si prega di fornire la motivazione per cui vorresti cambiare il tuo formatore.",
    myschedule_rechedule_next_info:
      "Per ulteriori informazioni sulle opzioni di riprogrammazione e cancellazione si prega di visitare il nostro",
    myschedule_rechedule_next_faq: "Portale FAQ.",
    myschedule_rechedule_next_noShow: "Non mostrare più questa pagina informativa",
    myschedule_rechedule_next_done: "Fatto",
    myschedule_rechedule_skipButton: "Salta",
    myschedule_upcoming_joinNow: "Partecipa ora",
    myschedule_cancel_question: "Sicuro di voler cancellare questa sessione?",
    myschedule_cancel_button: "Cancellare la sessione",
    myschedule_cancel_no: "No",
    myschedule_invalid_session: "Siamo spiacenti, questa sessione non è valida",
    myschedule_sessionDuraion_minutes: "Minuti",
    myschedule_homepage_view: "Vitualizza",
    myschedule_finished_status: "Finito",
    myschedule_reschedule_button: "Riprogramma",
    myschedule_addToCalendar_instr1: "Clicca sul",
    myschedule_addToCalendar_instr2:
      "pulsante download per accedere al tuo calendario Learnship. Dopo averlo scaricato potrai aggiungerlo al tuo calendario personale.",
    myschedule_addToCalendar_instr3:
      "Se hai già aggiunto un programma di Learnship al tuo calendario, assicurati di aver prima eliminato quello esistente.",
    myschedule_addToCalendar_instr4:
      "Scopri di più su come aggiungere il programma di Learnship al tuo calendario personale",
    myschedule_addToCalendar_instr5: "qui",
    myschedule_no_teacher_title: "Formatore non assegnato",
    myschedule_no_teacher_body:
      "Al momento non è possibile aggiungere alcuna sessione (Non è stato ancora assegnato un formatore). Si prega di contattare coach@globalenglish.com per continuare il tuo programma.",
    myschedule_no_all_sessions: "Nessuna sessione trovata",
    myschedule_no_upcoming_sessions: "Nessuna sessione imminente trovata",
    myschedule_no_missed_sessions: "Nessuna sessione persa trovata",
    myschedule_no_completed_sessions: "Nessuna sessione completata trovata",
    myschedule_status_lost: "Persa",
    myschedule_status_finished: "Finita",
    myschedule_status_completed: "Completata",
    myschedule_status_cancelled: "Cancellata",
    myschedule_status_inprogress: "In cours",
    myschedule_status_pending: "In sospeso",
    myschedule_status_active: "Attivo",
    myschedule_status_inplanning: "In programmazione",

    // my schedule page translations end
    // Progress page
    progress_title: "Il mio programma",
    progress_activity_report: "Report sulle attitivà",
    progress_test_results: "Risutati dei test",
    progress_productname_sprint_skills: "Competenze aziendali Sprint",
    progress_productname_reach_skills: "Competenze Reach",
    progress_skill_note:
      "Devi completare il 70% o più delle sessioni e delle attività del corso per avere diritto al certificato di completamento.",
    progress_overall_card_title_prework: "Esercizi di preparazione completati",
    progress_overall_card_title_homework: "Compiti completati",
    progress_overall_card_title_session: "Sessioni completate",
    progress_overall_card_title_certificate: "Certificato",
    progress_overall_card_title_skillsCompleted: "Competenze completate",
    progress_overall_card_title_badgesEarned: "Medaglie ottenute",
    progress_overall_card_title_missionsPassed: "Missioni compiute",
    progress_overall_card_title_timeInReach: "Tempo trascorso su Reach (HH:MM)",
    progress_noSubskill: "Non ci sono sotto competenze da mostrare.",
    progress_tab_nodata: "Non ci sono dati da mostrare.",
    progress_tab_notonboarded: "Completa il tuo onboarding per accedere ai tuoi rapporti",
    progress_activityreport_nodata:
      "Al momento non ci sono dati da mostrare qui. Continua a imparare e torna più tardi",
    progress_percentCompleted: "percentuale completata",
    progress_subskill_preworkTitle: "Pre-Lavoro",
    progress_subskill_homeworkTitle: "Compiti",
    progress_subskill_sessionTitle: "Sessione",
    progress_subskill_sessionStatusCompleted: "Completato",
    progress_subskill_sessionStatusNotCompleted: "Non completato",
    progress_subskill_sessionStatusNoSessions: "Nessuna sessione",
    progress_subskill_sessionStatusAbsent: "Assente",
    progress_subskill_sessionNoDate: "N/A",
    progress_activity_tooltip_totaltime: "Tempo totale",
    progress_activity_tooltip_activitiesCompleted: "Attività completate",
    progress_activity_tooltip_reachMissionsCompleted: "Missioni completate su Reach",
    progress_activity_tooltip_timeinhhmm: "Ora in HH:MM",
    progress_activity_tabDaily: "Giornaliero",
    progress_activity_tabWeekly: "Settimanale",
    progress_activity_tabMonthly: "Mensile",
    progress_activity_tabQuarterly: "Trimestrale",
    progress_activity_tabQuarter: "Trimestre",
    progress_activity_tabYearly: "Annuale",
    progress_acitivity_Minutes: "Minuti",
    progress_acitivity_legend_selfpaced: "Tempo di apprendimento personalizzato",
    progress_acitivity_legend_trainerLed: "Tempo trascorso con la guida di un formatore",
    progress_acitivity_legend_recommended: "Consigliato",
    progress_testresults_table_testname: "Nome del Test",
    progress_testresults_table_scores: "Punteggio",
    progress_testresults_table_date: "Data",
    progress_testresults_placed_text: "Placed",
    progress_test_result_timer_text: "*Your test results will appear in 24 hours.",
    progress_testresults_info: "I risultati dei test verranno visualizzati entro le prossime 24 ore.",
    progress_inprogress: "In corso",
    progress_totalscore: "Punteggio totale",
    progress_placedText: "Posizionamento",
    progress_button_viewscore: "Vedi il report dettagliato",
    progress_certificate_download_success: "Daownload riuscito",
    progress_partText: "Parte",
    progress_emptyPartText: "Altro",
    progress_overall_card_title_badge: "Badge",
    progress_total_correctness_percentage: "Your success score is: ",
    progress_badge_dialog_box_title:
      "Al fine di ottenere un certificato di completamento, è necessario completare almeno il 70% degli esercizi digitali.",
    progress_badge_dialog_box_golden: "Con un punteggio dell’80% si ottiene una medaglia d’oro",
    progress_badge_dialog_box_silver: "Con un punteggio tra il 70% e il 79% si ottiene una medaglia d’argento",
    progress_badge_dialog_box_bronze: "Con un punteggio tra il 50% e il 69% si ottiene una medaglia di bronzo",
    progerss_badge_dailog_box_digitalActivities:
      "Il punteggio viene calcolato in base alla tua prestazione e all’impegno dimostrato nelle attività digitali online",
    progress_badge_dailog_box_liveSessions:
      "Il punteggio viene calcolato in base alla tua prestazione e all’impegno dimostrato nelle attività digitali online e nelle sessioni live",
    progress_elevate_dialog_box_liveSessions:
      "The success score is calculated based on your performance and engagement with live sessions",
    //EO Progress page
    //Email Templates
    languageSelect: "Select a language",
    wcGroup1: "Scuse",
    wcGroup2: "Reclami",
    wcGroup3: "Complimenti",
    wcGroup4: "Congratulazioni",
    wcGroup5: "Documenti",
    wcGroup6: "Inviti",
    wcGroup7: "Candidature di lavoro",
    wcGroup8: "Marketing e commerciale",
    wcGroup9: "Riunioni",
    wcGroup10: "Comunicazioni",
    wcGroup11: "Ordini",
    wcGroup12: "Informazioni sui prezzi",
    wcGroup13: "Richieste",
    wcGroup14: "Ringraziamenti",
    wcTitle11: "Scuse per il ritardo di un progetto",
    wcTitle12: "Scuse per un errore contabile",
    wcTitle13: "Scuse per un ritardo di una spedizione",
    wcTitle14: "Scuse per la consegna di merci danneggiate",
    wcTitle15: "Scuse per la mancata partecipazione a una riunione",
    wcTitle21: "Reclamo generico",
    wcTitle22: "Reclamo per un problema con un prodotto",
    wcTitle23: "Reclamo per un addebito a un cliente superiore al costo",
    wcTitle31: "Complimenti a un collega per un progetto",
    wcTitle32: "Complimenti per il servizio di assistenza clienti",
    wcTitle33: "Complimenti per un prodotto",
    wcTitle41: "Congratulazioni per una promozione (formali)",
    wcTitle42: "Congratulazioni per una promozione (informali)",
    wcTitle43: "Congratulazioni per un evento personale",
    wcTitle51: "Documento richiesto",
    wcTitle52: "Modulo d'ordine o d'acquisto",
    wcTitle53: "Fattura",
    wcTitle61: "Invito a un evento sociale",
    wcTitle62: "Invito a un evento lavorativo",
    wcTitle63: "Accettare un invito",
    wcTitle64: "Declinare un invito",
    wcTitle65: "Annullare un evento lavorativo",
    wcTitle71: "Confermare la ricezione di una domanda",
    wcTitle81: "Annuncio di un nuovo prodotto",
    wcTitle82: "Annuncio di un nuovo rappresentante d'area",
    wcTitle83: "Demo di un nuovo prodotto",
    wcTitle84: "Cambiamento di indirizzo di fatturazione",
    wcTitle85: "Follow-Up dopo una prima riunione commerciale",
    wcTitle86: "Dare il benvenuto a un nuovo cliente",
    wcTitle87: "Messaggio augurale agli azionisti o ai clienti",
    wcTitle91: "Proposta di orario per una riunione",
    wcTitle92: "Confermare una riunione",
    wcTitle93: "Rimandare una riunione",
    wcTitle94: "Annullare una riunione",
    wcTitle95: "Riepilogare una riunione",
    wcTitle101: "Conto sospeso",
    wcTitle102: "Richiedere la chiusura di un conto",
    wcTitle111: "Conferma di un ordine",
    wcTitle112: "Conferma di avvenuta spedizione",
    wcTitle113: "Annullare un ordine",
    wcTitle114: "Modificare un ordine",
    wcTitle115: "Confermare una consegna",
    wcTitle121: "Fornire informazioni sui prezzi",
    wcTitle122: "Accettare un preventivo",
    wcTitle123: "Rifiutare un preventivo",
    wcTitle131: "Chiedere dei chiarimenti su alcune informazioni",
    wcTitle132: "Chiedere informazioni su un prodotto",
    wcTitle133: "Chiedere informazioni su un servizio",
    wcTitle141: "Ringraziamenti generici",
    Blob: "I modelli di e-mail coprono una vasta gamma di argomenti commerciali. Seleziona il modello desiderato ed esportalo direttamente nel tuo client di posta elettronica per modificarlo.",
    OpenInEmail: "Apri nell’ e-mail",
    Quote1: "Attualmente esistono 3,3 miliardi di account e-mail nel mondo.",
    Quote1By: "Mashable",
    Quote2: "La posta elettronica genera un profitto quasi doppio rispetto ad altri canali.",
    Quote2By: "Contatto di marketing diretto",
    Quote3: "Ogni secondo vengono inviati 3,5 milioni di e-mail.",
    Quote3By: "Contatto di marketing",
    SelectACategory: "Selezionare una categoria",
    Title: "Modelli di e-mail",
    WatchTutorial: "Guardate un video tutorial",
    String: "Quote1",
    //Culture Notes Dropdowns
    NoAm: "Nord America",
    Cenam: "America centrale",
    SoAm: "Sud America",
    EUR: "Europa",
    ASIA: "Asia",
    CenASIA: "Asia Centrale",
    SoEASIA: "Sud Est asiatico",
    MidEAST: "Medio Oriente",
    AFR: "Africa",
    AUST: "Australia",
    Cana: "Canada",
    Mexi: "Messico",
    Uniteds: "Stati Uniti d'America",
    CostaR: "Costa Rica",
    DomRep: "Repubblica Domenicana",
    Guate: "Guatemala",
    Jama: "Giamaica",
    Panam: "Panama",
    TriniTob: "Trinidad e Tobago",
    Arge: "Argentina",
    Braz: "Brasile",
    Chil: "Cile",
    Vene: "Venezuela",
    Colomb: "Colombia",
    Peru: "Perù",
    Urug: "Uruguay",
    Austria: "Austria",
    Belg: "Belgio",
    Bulg: "Bulgaria",
    Croatia: "Croazia",
    Czec: "Repubblica Ceca",
    Denm: "Danimarca",
    Finl: "Finlandia",
    Fran: "Francia",
    Germ: "Germania",
    Greec: "Grecia",
    Hung: "Ungheria",
    Icel: "Islanda",
    Irel: "Irlanda",
    Ital: "Italia",
    Lith: "Lituania",
    Luxem: "Lussemburgo",
    Neth: "Olanda",
    Norw: "Norvegia",
    Pola: "Polonia",
    Port: "Portogallo",
    Roma: "Romania",
    Russ: "Federazione russa",
    Serb: "Serbia",
    Slovakia: "Slovacchia",
    Slovania: "Slovenia",
    Spai: "Spagna",
    Swed: "Svezia",
    Swit: "Svizzera",
    Turk: "Turchia",
    Ukra: "Ucraina",
    Unitedk: "Regno Unito",
    Chin: "Cina",
    Hong: "Hong Kong",
    Indi: "India",
    Japa: "Giappone",
    Mongo: "Mongolia",
    Pakis: "Pakistan",
    SoKore: "Corea del Sud",
    SriLan: "Sri Lanka",
    Taiw: "Taiwan",
    Afgh: "Afghanistan",
    Azer: "Azerbaigian",
    Kaza: "Kazakistan",
    Camb: "Cambogia",
    Indo: "Indonesia",
    Malay: "Malesia",
    Phil: "Filippine",
    Sing: "Singapore",
    Thai: "Tailandia",
    Viet: "Vietnam",
    Bah: "Bahrain",
    Iran: "Iran",
    Iraq: "Iraq",
    Isra: "Israele",
    Jor: "Giordania",
    Kuw: "Kuwait",
    Leb: "Libano",
    Oma: "Oman",
    Qat: "Qatar",
    SauArb: "Arabia Saudita",
    UAE: "Emirati Arabi Uniti",
    Alger: "Algeria",
    Angol: "Angola",
    Egyp: "Egitto",
    Ghana: "Ghana",
    Guin: "Guinea",
    Keny: "Kenya",
    Malaw: "Malawi",
    Moroc: "Marocco",
    Mozam: "Mozambico",
    Nige: "Nigeria",
    SoAfr: "Sud Africa",
    Tanz: "Tanzania",
    Ugan: "Uganda",
    Zamb: "Zambia",
    Austra: "Australia",
    NewZea: "Nuova Zelanda",
    //Culture Notes Dropdowns End
    culturenotes_mainintrotext:
      "Acquisisci familiarità con la cultura delle regioni importanti per la tua azienda e per la tua vita professionale.",
    culturenotes_useculturalinfo:
      "Usa le informazioni culturali per prepararti alle riunioni importanti con clienti e colleghi di tutto il mondo.",
    culturenotes_topicfamiliarize:
      "Familiarizza con gli usi e i costumi di altre culture, come l’orario lavorativo, le cene d'affari, i regali, ecc.",
    culturenotes_topiclearnculture:
      "Scopri le consuetudini, le differenze culturali e le abitudini locali per evitare di commettere errori o gaffe culturali.",
    culturenotes_tmaworldtext:
      "I report sui vari paesi vengono sviluppati dal nostro partner TMA World e sono disponibili in versione scaricabile PDF.",
    culturenoteslocation_viewbytopic: "Visualizza per argomento",
    culturenoteslocation_viewbycountry: "Visualizza per località",
    culurecenter_disclaimer_title: "Liberatoria",
    culturecenter_disclaimer:
      "Ti preghiamo di considerare le informazioni che leggerai come una guida generale, che vuole essere solo un punto di partenza per cominciare a familiarizzare con una nuova cultura. Questo strumento ti aiuterà a conoscere i modelli culturali comuni, che fungeranno da schema di riferimento per una migliore comprensione e interpretazione delle differenze culturali nel comportamento, negli atteggiamenti e nelle reazioni delle persone. Tuttavia, è importante tenere presente che le caratteristiche comuni di una particolare cultura variano sia a livello regionale sia in base alle personalità individuali.",
    culturecenter_intercept_title: "Le Note Culturale sono tornate!​​",
    culturecenter_intercept_text1:
      "Dopo un piccolo “ritocco”, siamo lieti di annunciare che le Note Culturali sono di nuovo qui!",
    culturecenter_intercept_text2:
      "Grazie alla sezione sulle Note Culturali avrai l’opportunità di conoscere meglio le consuetudini e le abitudini professionali di 20 nazioni del mondo, incluse USA, Canada, Messico, Cina, Giappone, India e tante altre…",
    culturecenter_intercept_direct: "Vai alle Note Culturali​",
    dailyNewsFeed_resources: "Risorse",
    dailyNewsFeed_daily_News: "Notizie giornaliere con esercizi mirati",
    dailyNewsFeed_newsfeedoftheday: "Le notizie del giorno con esercizi mirati",
    dailyNewsFeed_feedcontent:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut auctor orci at quam porta dictum. Duis id vestibulum dui. Phasellus interdum augue magna, in tempus velit imperdiet id.",
    dailyNewsFeed_noData:
      "Siamo spiacenti, non siamo in grado di fornire le notizie con gli esercizi, si prega di riprovare più tardi.",
    dailyNewsFeed_viewMoreCategories: "Visualizza ulteriori informazioni",
    // Email templates end
    //Error Page Translations
    error_not_found: "Oops! Pagina non trovata.",
    error_contact_csm: "Se hai bisogno di aiuto, puoi contattare il tuo Customer Success Manager.",
    error_under: "In",
    error_maintenance: "Manutenzione",
    error_under_maintenance: "Il nostro sito è attualmente in fase di manutenzione programmata.",
    error_inconvenience: "Ci dispiace per l’inconveniente",
    error_tryagain: "Si prega di riprovare più tardi.",
    error_tryagainMins: "Si prega di riprovare tra",
    error_minutes: "minuti.",
    error_hours: "ore",
    error_oops: "Oops!",
    error_permission_denied: "Non sei autorizzato a vedere questa pagina",
    error_link_home: "Home page",
    error_contact_admin:
      "Se hai bisogno di aiuto, puoi contattare il tuo amministratore <donottrans> Learnship </donottrans>",
    error_sorry: "Spiacenti",
    error_load: "C’è stato un problema nel loading di questa pagina.",
    error_clear_cache: "Svuota la cache del browser, controlla la connessione Internet e riprova.",
    error_contact: "Ti preghiamo di contattare il nostro",
    error_contact_cst: "Customer support team",
    error_forhelp: "In caso avessi bisogno di aiuto",
    error_having_trouble: "Hai ancora problemi?",
    //Accents and Dialects Dropdowns
    AF: "Africa",
    AS: "Asia",
    AU: "Australia/Oceania",
    CA: "Caraibi",
    CE: "America centrale",
    EU: "Europa",
    MI: "Medio Oriente",
    NO: "America del nord",
    SO: "America del sud",
    CAMER: "Camerun",
    EGYPT: "Egitto",
    ETHIO: "Etiopia",
    GHANA: "Ghana",
    GUINE: "Guinea",
    NIGER: "Nigeria",
    SOUTH: "Sud Africa",
    TANZA: "Tanzania",
    AFGHA: "Afghanistan",
    CHINA: "Cina",
    INDIA: "India",
    INDON: "Indonesia",
    JAPAN: "Giappone",
    KAZAK: "Kazakhstan",
    LEBAN: "Libano",
    MONGO: "Mongolia",
    NORTH: "Vietnam del nord",
    PAKIS: "Pakistan",
    PHILI: "Filippine",
    SINGA: "Singapore",
    KOREA: "Corea",
    SRI_L: "Sri Lanka",
    TAIWA: "Taiwan",
    THAIL: "Thailandia",
    TURKM: "Turkmenistan",
    AUSTR: "Australia",
    FIJI_: "Fiji",
    NEW_Z: "Nuova Zelanda",
    BERMU: "Bermuda",
    CUBA_: "Cuba",
    HAITI: "Haiti",
    COSTA: "Costa Rica",
    GUATE: "Guatemala",
    MARTI: "Martinica (francese)",
    TRINI: "Trinidad e Tobago",
    AUSTRI: "Austria",
    BELAR: "Bielorussia",
    BELGI: "Belgio",
    BULGA: "Bulgaria",
    CYPRU: "Cipro",
    CZECH: "Repubblica Ceca",
    DENMA: "Danimarca",
    ENGLA: "Inghilterra",
    FINLA: "Finlandia",
    FRANC: "Francia",
    GEORG: "Georgia",
    GERMA: "Germania",
    GREEC: "Grecia",
    HUNGA: "Ungheria",
    IRELA: "Irlanda",
    ITALY: "Italia",
    MACED: "Macedonia del Nord",
    NETHE: "Paesi Bassi",
    NORTHI: "Irlanda del nord",
    POLAN: "Polonia",
    ROMAN: "Romania",
    RUSSI: "Federazione russa",
    SCOTL: "Scozia",
    SPAIN: "Spagna",
    SWEDE: "Svezia",
    SWITZ: "Svizzera",
    TURKE: "Turchia",
    UKRAI: "Ucraina",
    WALES: "Galles",
    IRAN_: "Iran",
    IRAQ_: "Iraq",
    ISRAE: "Israele",
    KUWAI: "Kuwait",
    SAUDI: "Arabia Saudita",
    SYRIA: "Siria",
    CANAD: "Canada",
    MEXIC: "Messico",
    ARGEN: "Argentina",
    BRAZI: "Brasile",
    CHILE: "Cile",
    COLOM: "Colombia",
    PARAG: "Paraguay",
    PERU_: "Perù",
    VENEZ: "Venezuela",
    RPTitle: "Rainbow passage",
    CGACTitle: "Comma Gets a Cure",
    accentsAndDialects_heading: "Accenti e dialetti",
    US: "Stati Uniti d'America",
    ALABA: "Alabama",
    ALASK: "Alaska",
    ARKAN: "Arkansas",
    CALIF: "California",
    FLORI: "Florida",
    GEORG_US: "Georgia",
    HAWAI: "Hawaii",
    ILLIN: "Illinois",
    INDIA_US: "Indiana",
    KANSA: "Kansas",
    KENTU: "Kentucky",
    LOUIS: "Louisiana",
    MAINE: "Maine",
    MARYL: "Maryland",
    MASSA: "Massachusetts",
    MICHI: "Michigan",
    MINNE: "Minnesota",
    MISSI: "Mississippi",
    MISSO: "Missouri",
    MONTA: "Montana",
    NEBRA: "Nebraska",
    NEW_H: "New Hampshire",
    NEW_J: "New Jersey",
    NEW_Y: "New York",
    NCARO: "Nord Carolina",
    NDAKO: "Nord Dakota",
    OHIO_: "Ohio",
    OKLAH: "Oklahoma",
    PENNS: "Pennsylvania",
    SOUTH_US: "Sud Carolina",
    TENNE: "Tennessee",
    TEXAS: "Texas",
    VIRGI: "Virginia",
    WEST_: "Virginia occidentale",
    WISCO: "Wisconsin",
    //Accents and Dialects Dropdowns End
    manager_email_managertext:
      "La tua azienda ha richiesto un resoconto mensile per il tuo manager al fine di conoscere i progressi che hai avuto con Learnship. Fornisci l'indirizzo email del tuo manager qui in basso.",
    // survey and notification
    notification_description_plural:
      "{days} di giorni che restano per completare il questionario. Deve essere completato entro {date}.",
    notification_description_singular:
      "Resta solo 1 giorno per completare il questionario. Si deve completare entro {date}.",
    notification_maintenance_message: "Halo sarà sottoposto a manutenzione il giorno {date} alle {time}.",
    //renewal
    renewal_welcome: "Bentornato nel servizio Learnship!",
    renewal_text:
      "La tua licenza Learnship scade il {date}, {month} {year} Per migliorare continuamente le tue capacità di comunicazione in inglese, rinnova oggi stesso la licenza. Il tuo piano di studi e tutto il lavoro fatto verranno salvati e riprenderai lo studio dal tuo livello attuale.",
    renewal_later: "Richiedimelo in seguito.",
    renewal_affirmative: "Desidero rinnovare la mia licenza.",
    renewal_negative: "Non desidero rinnovare la mia licenza.",
    renewal_yes: "SÍ",
    renewal_no: "NO",
    courselevel: "Livello del corso",
    currentunit: "Unità attuale",
    upcomingsession: "In arrivo",
    viewschedule: "Visualizza i miei corsi",
    currentskills: "Competenze",
    currentsubskills: "Sotto-competenze",
    // TWT translations
    twt_talk_with_teacher_title: "Talk with the Teacher",
    twt_sub_heading:
      "Esercita le tue abilità di conversazione con un formatore e con gli altri studenti presenti nella nostra classe virtuale!",
    twt_select_sessions: "Seleziona le tue sessioni",
    twt_view_schedule_title: "Visualizza i tuoi corsi e aggiungili al calendario",
    twt_next_week: "Settimana successiva",
    twt_previous_week: "Settimana precedente",
    twt_add_to_calendar: "Aggiungi al calendario",
    twt_view_more: "Ulteriori informazioni",
    twt_topic: "Argomento",
    twt_class_policy_title: "Talk with the Teacher (TWT) - Politiche e Linee guida",
    twt_class_policy_subHeading:
      "Le seguenti policy e linee guida sono importanti per assicurare che la tua esperienza con Talk with the Teacher sia formativa e piacevole. Ti preghiamo di leggerle con attenzione.",
    twt_class_policy_list01:
      "Il tuo accesso potrebbe essere limitato ad una sessione a settimana*. Le nostre classi virtuali hanno una capienza massima di 8 studenti. Consiglio: arriva poco prima dell’inizio della sessione. Le classi sono accessibili solo durante i primi 10 minuti di ogni sessione. Per esempio, una sessione che inizia alle 9:00 sarà accessibile fino alle 9:10. Dopo i primi 10 minuti, non potrai più accedere alla sessione.",
    twt_class_policy_list02_sub1:
      "Quando accedi alla classe, inserisci il nome, la città, il paese e il livello nel riquadro della Chat.",
    twt_class_policy_list02_sub2: "Mi chiamo Leo, vengo da San Paolo, Brasile. Sono al Livello 6.",
    twt_class_policy_list02_sub3: "L'istruttore attiverà il microfono e apparirà l'icona del microfono.",
    twt_class_policy_list03:
      "Se hai un problema tecnico, contatta l’Assistenza Clienti. Seleziona Guida nella barra superiore della piattaforma o contatta un rappresentante dell’Assistenza utilizzando lo strumento di Chat istantanea che trova in alto in ogni pagina. Ti preghiamo di non chiedere supporto tecnico all’insegnante.",
    twt_class_policy_list04:
      "Prima di entrare in una classe online, guarda la Sessione di Orientamento di Talk with the Teacher che ti fornirà informazioni utili sulla partecipazione ai corsi online.",
    twt_class_policy_list05:
      "Ci sono quattro livelli di classi con Talk with the Teacher: Principiante, Intermedio, Avanzato e Tutti I Livelli. Dovresti frequentare una classe che si adatta alle tue competenze in inglese. Per esempio, se sei nei livelli 0 – 3, devi frequentare la classe Talk with the Teacher per principianti. Tutti gli studenti possono frequentare la classe per Tutti i livelli. Se partecipi a una classe Talk with the Teacher che non è adatta alle tue competenze di inglese, il tuo istruttore ti informerà che non sei nella classe giusta e la tua sessione terminerà.",
    twt_class_policy_list06:
      "Se desideri ascoltare una sessione online senza parlare, ti consigliamo di farlo solo per una sessione a settimana. Successivamente, dovrai partecipare parlando durante le lezioni. Potrai partecipare da uditore ad un Massimo di 4 lezioni a Programma. Se superi questo limite, e continui a non partecipare (parlando) alle lezioni, le tue sessioni termineranno.",
    twt_class_policy_ok: "Ok",
    twt_max_multi_window_error_message:
      "Sei già entrato in questa sessione da un altro dispositivo. Ti preghiamo di effettuare il logout prima di partecipare dal dispositivo attualmente in uso.",
    twt_max_capacity_error_message:
      "Siamo spiacenti, non puoi partecipare a questa sessione perché ha già raggiunto la capienza massima di partecipanti. Ti preghiamo di partecipare ad un’altra sessione",
    twt_notification_message:
      "C’è un’altra sessione di conversazione che sta iniziando proprio adesso. Ti va di partecipare?",
    twt_limit_message: "Avete già frequentato una lezione questa settimana.",
    twt_session_unavailable: "Nessuna sessione disponibile",
    twt_select_language: "Seleziona lingua",
    //Vocabulary center translations
    search:"Cerca e ",
    vocab_center_product_headline: "Sezione Vocabolario",
    vocab_center_search_word: "Cerca e aggiungi parola",
    vocab_center_add_wordlist: "Aggiungi lista di parole",
    vocab_center_edit_wordlist: "Modifica lista di parole",
    vocab_center_delete_wordlist: "Cancella lista di parole",
    vocab_center_options_text: "Opzioni",
    vocab_center_add_word: "Aggiungi parola",
    vocab_center_add_text: "Aggiungi",
    vocab_center_delete_wordlist_warning_message:
      "Tutte le parole contenute nella lista saranno cancellate. Clicca Sì per cancellarle.",
    vocab_center_yes_text: "Sì",
    vocab_center_new_wordlist: "Nuova lista di parole",
    vocab_center_created_wordlist_success_message: "Hai creato una nuova lista di parole",
    vocab_center_updated_wordlist_success_message: "Hai aggiornato la nuova lista di parole",
    vocab_center_okay_text: "Okay",
    vocab_center_new_word_text: "Nuova parola",
    vocab_center_enter_word_text: "Inserisci una parola",
    vocab_center_wordlist_exists: "This wordlist already exists.",
    vocab_center_word_exists_in_wordlist_warning_message: "Questa parola è già presente in questa lista",
    vocab_center_save_text: "Salva",
    vocab_center_new_word_message: "Questa parola non esiste. Desideri crearne una nuova definizione?",
    vocab_center_pos_label: "Parte del discorso",
    vocab_center_select_wordlist_text: "Seleziona una lista di parole",
    vocab_center_word_label: "Parole",
    vocab_center_update_wordlist: "Aggiorna la lista di parole",
    vocab_center_definition_label: "Definizione",
    vocab_center_translation_label: "Traduzione",
    vocab_center_sentence_label: "Frase",
    vocab_center_note_label: "Nota",
    vocab_center_cancel_text: "Cancella",
    vocab_center_delete_word_text: "Cancella parola",
    vocab_center_delete_word_warning_message: "Sei sicuro di voler eliminare questa parola dalla Lista?",
    vocab_center_note_updated_message: "Hai aggiornato le tue note!!!",
    vocab_center_close_text: "Chiudi",
    vocab_center_no_definition_text: "Nessuna definizione disponibile",
    vocab_center_no_translation_text: "Nessuna traduzione disponibile",
    vocab_center_no_sentence_text: "Nessuna frase disponibile",
    vocab_center_no_note_text: "Nessuna nota aggiunta",
    vocab_center_word_save_message: "Hai salvato la parola nella tua Lista",
    vocab_center_word_exists_error_message: "La parola selezionata è già presente nella lista",
    vocab_center_submit_text: "Invia",
    vocab_center_delete_text: "Cancella",
    vocab_center_edit_text: "Modifica",
    vocab_center_no_word_message: "Oops! Nella tua lista non ci sono parole. Aggiungi nuove parole!",
    vocab_center_no_wordlist_message: "Oops! Nella tua lista {wordListName} non ci sono parole. Aggiungi nuove parole!",
    vocab_center_enter_wordlist_text: "Inserisci una lista di parole",
    vocab_center_feature_text:
      "Senza grammatica, si può comunicare pochissimo. Senza vocabolario non si può comunicare per niente. - David Wilkins",
    vocab_center_feature_summary:
      "Esplora ed espandi il tuo lessico senza sforzo con il Vocabulary Center, la tua porta d'accesso per scoprire e padroneggiare nuove parole senza problemi",
    // Stress and inotation translations
    stress_intonation_product_headline: "Accento e intonazione",
    stress_intonation_product_description:
      "Rendi il tuo inglese più naturale e comprensibile usando gli accenti, il ritmo e l’intonazione nel modo giusto.",
    // Sounds of English translations
    soe_product_headline: "I suoni dell’inglese",
    soe_product_description: "Migliora le tue abilità comunicative pronunciando correttamente i suoni dell’inglese.",
    soe_product_vowels: "Vocali",
    soe_product_consonants: "Consonanti",
    soe_product_language_selection:
      "Seleziona la tua lingua dal menu a tendina per trovare i suoni che potrebbero essere più difficili per i parlanti della tua lingua. Quindi seleziona “I miei suoni” per ritrovare le pronunce con cui hai avuto più difficoltà durante le attività di Pratica di Pronuncia e di Comunicazione.",
    // Writing center
    wc_feature_headline: "Centro di scrittura",
    wc_feature_description: "Migliora la tua capacità di scrittura professionale grazie alle nostre risorse dedicate.",
    wc_feature_guideGroup1: "Problemi comuni di scrittura",
    wc_feature_guideGroup2: "Comunicazioni professionali generiche",
    wc_feature_guideGroup3: "Documenti aziendali",
    wc_feature_guideTitle11: "Documenti scritti poco chiari: le cause",
    wc_feature_guideTitle12: "Errori comuni di scrittura",
    wc_feature_guideTitle13: "Problemi con i verbi",
    wc_feature_guideTitle21: "Franchezza nelle comunicazioni aziendali",
    wc_feature_guideTitle22: "Il linguaggio commerciale e del marketing",
    wc_feature_guideTitle23: "Espressioni idiomatiche professionali di uso comune",
    wc_feature_guideTitle31: "E-mail efficaci",
    wc_feature_guideTitle32: "Presentazioni: suggerimenti generali",
    wc_feature_guideTitle33: "Presentazioni: aperture d'effetto",
    // sso leaner intercept
    learners_intercept_title: "IMPORTANT NOTICE",
    learners_intercept_text1:
      "The way you log on to Learnship is changing! Citi has partnered with Learnship to enable Single Sign On access for all global learners. As of 9:00am CEST on November 18, 2022, you will be required to go to ",
    learners_intercept_text2: "It is important to note that you will no longer be able to log-on via\u202f",
    learners_intercept_text3: "Please take note of this change and bookmark the new page. ",
    learners_intercept_text4: "For support, please reach out to your local HR contact or\u202f",
    // google learner intercept
    google_intercept_title: "Important Notice",
    google_intercept_subtitle: "The way you log on to Learnship is changing! ",
    google_intercept_text1: "Google has partnered with Learnship to enable ",
    google_intercept_text2: "for all learners. ",
    google_intercept_text3: "Effective from ",
    google_intercept_text4: "you will be required to go to ",
    google_intercept_text5: "It is important to note that, from ",
    google_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    google_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    google_intercept_text8: "For support, please reach out to ",
    google_sso_text: " Single Sign On (SSO) ",
    google_dd_mmm_text: "18th May",
    google_intercept_time: "10:00am CEST",
    google_intercept_date: "18 May 2023",
    google_intercept_on_text: "on",
    google_link_not_work: "This link will not work before that date.",
    learnship_note_google: "Note: ",
    learnship_family_note_google:
      "This change only applies to Googlers. Family members will continue to log in as before.",
    // nestle learner intercept
    nestle_intercept_title: "Important Notice",
    nestle_intercept_subtitle: "The way you log on to Learnship is changing! ",
    nestle_intercept_text1: "Nestlé has partnered with Learnship to enable ",
    nestle_intercept_text2: "for all learners in Switzerland. ",
    nestle_intercept_text3: "Effective from ",
    nestle_intercept_text4: "you will be required to go to ",
    nestle_intercept_text5: "It is important to note that, from ",
    nestle_intercept_text6: ", you will no longer be able to access your Learnship course through ",
    nestle_intercept_text7:
      "Please make a note of the above change and remember to delete any old bookmarks and replace it with the new link.",
    nestle_intercept_text8: "For support, please reach out to your ",
    nestle_service_desk: "Nestlé ServiceDesk",
    nestle_dd_mmm_text: "4th May",
    nestle_sso_text: " Single Sign On (SSO) ",
    nestle_intercept_time: "10:00am CEST",
    nestle_intercept_date: "4th May 2023",
    nestle_intercept_on_text: "on",
    nestle_intercept_or_text: "or ",
    nestle_link_not_work: "This link will not work before that date.",
    learnship_note_nestle: "Note: ",
    learnship_family_note_nestle:
      "This change only applies to Nestlé employees. Family members will continue to log in as before.",
      welcome_Contact_number_helper_text:"Per garantire un'assistenza tempestiva e un supporto personalizzato, ti consigliamo vivamente di fornire anche il tuo numero di contatto"
  },
};
